import {register} from 'swiper/element/bundle';

// Register Swiper. This is required to use Swiper in Vue components.
// It should be done only once in the application, typically in the main entry file.

let isRegistered = false;

export function registerSwiper() {
  if (!isRegistered) {

    register();
    isRegistered = true;
  }
}
